import {
  getInterestGroupsQueryOptions,
  getInterestGroupQueryOptions,
  getInterestGroupsByAdPlatformQueryOptions
} from "../../queries/interestGroups";
import { getAdPlatformsQueryOptions } from "../../queries/adPlatforms";

// necessary entities are pre-fetched when a user hover a 'create interestGroup' or a 'edit interestGroup' link
export const interestGroupFormLoader = ({ context: { queryClient } }) => {
  queryClient.ensureQueryData(getAdPlatformsQueryOptions());
};

// interestGroups are pre-fetched when a user hover a 'interestGroups' link
export const interestGroupListLoader = ({ context: { queryClient } }) => {
  queryClient.ensureQueryData(getInterestGroupsQueryOptions());
};

// interestGroups are pre-fetched when a user hover a 'interestGroups' link within a adPlatform
export const interestGroupListByAdPlatformLoader = ({
  params,
  context: { queryClient },
}) => {
  const { adPlatformId } = params;
  queryClient.ensureQueryData(
    getInterestGroupsByAdPlatformQueryOptions(adPlatformId, queryClient)
  );
};

// interestGroup is pre-fetched when a user hover a 'view interestGroup' link
export const interestGroupViewLoader = ({ params, context: { queryClient } }) => {
  const { interestGroupId } = params;
  queryClient.ensureQueryData(getInterestGroupQueryOptions(interestGroupId, queryClient));
};
